import React from 'react';

export interface ICalculatorExecutionProps {
  description?: string;
  results: any[];
  resultCalculator: number
  defaultResult: string
  isDate: boolean
}

export interface ICalculatorExecutionState {
  value: string
}

export default class CalculatorExecutionComponent extends React.Component<ICalculatorExecutionProps, ICalculatorExecutionState> {
  constructor(props: ICalculatorExecutionProps) {
    super(props); 
  }
  valideResult(value : any){
    return value && !isNaN(value) && isFinite(value)
  }
  handleTypedate(score: number){
    if(this.props.isDate){
      return `${score}`
    }
    return score.toString()
    
  }
  handleScoreResults() {
    const {resultCalculator} = this.props
    const res = this.props.results.find((e: any) => {
      return (resultCalculator >= e.min && resultCalculator <= e.max)
    })
    let msg = this.props.defaultResult
    if (res) {
      msg = res.label
    }
    msg = this.valideResult(resultCalculator) ? msg.replace(/{{value}}/g,this.handleTypedate(resultCalculator)) : 'Esperando por valores para calcular'
    return { __html: msg }
  }
  
  render() {
    return (
        <>
          <p>{this.props.description}</p>
          <p dangerouslySetInnerHTML={this.handleScoreResults()} />
        </>
    );
  }
}